import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';
import { useAuth } from '@/contexts';
import { fetchListaDocumentosItens } from '../api/ListaDocumentosItensApi';
import { ListaItensPayload, ListaItensResponse } from '../types';

export function useListaDocumentosItens(
  payload: ListaItensPayload,
  options?: Omit<UseQueryOptions<ListaItensResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const { toast } = useToast();
  const { user } = useAuth();
  const cnpjGestor = user?.cnpj;

  const query = useQuery<ListaItensResponse, Error>({
    queryKey: ['documentos-itens', cnpjGestor, payload],
    queryFn: () => fetchListaDocumentosItens(payload),
    staleTime: 5 * 60 * 1000,
    ...options,
    enabled:
      (options?.enabled ?? true) &&
      !!cnpjGestor &&
      !!payload.chave_acesso &&
      !!payload.data_emissao_de &&
      !!payload.data_emissao_ate,
  });

  useEffect(() => {
    if (query.error) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar itens',
        description: 'Não foi possível carregar os itens do documento. Tente novamente.',
      });
    }
  }, [query.error, toast]);

  return query;
}
